import Vue from "vue";
// import { createApp } from 'vue'
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import axios from "./axios";
import global from "./globalFun";
//引入 echarts
import * as echarts from "echarts";

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

//注册组件
Vue.prototype.$echarts = echarts;

Vue.use(Element);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// 接收父页面的认证信息并注入本地存储，支持嵌入模式
try {
  window.addEventListener("message", function(e) {
    var data = e && e.data ? e.data : null;
    if (data && data.type === "AUTH") {
      if (data.token != null) {
        try {
          localStorage.setItem("token", data.token);
        } catch (err) {}
      }
      if (data.userId != null) {
        try {
          localStorage.setItem("userId", String(data.userId));
        } catch (err) {}
      }
      if (data.userName != null) {
        try {
          localStorage.setItem("username", String(data.userName));
        } catch (err) {}
      }
      if (data.userRole != null) {
        try {
          localStorage.setItem("userRole", String(data.userRole));
        } catch (err) {}
      }
      if (data.hrAccount != null && String(data.hrAccount)) {
        try {
          localStorage.setItem("username", String(data.hrAccount));
        } catch (err) {}
      }
      // 无界面自动登录：若收到账号与明文密码，则主动调用登录接口，避免展示登录页
      if (data.hrAccount && data.hrPassword) {
        try {
          var u = encodeURIComponent(String(data.hrAccount || ""));
          var p = encodeURIComponent(String(data.hrPassword || ""));
          axios
            .post("/api/login?username=" + u + "&password=" + p)
            .then(function(res) {
              var hdrs = res && res.headers ? res.headers : {};
              var jwt =
                hdrs && (hdrs["token"] || hdrs["Token"] || hdrs["TOKEN"]);
              if (jwt) {
                try {
                  localStorage.setItem("token", jwt);
                } catch (err) {}
                try {
                  store.commit("setToken", jwt);
                } catch (err) {}
              }
              try {
                store.commit("setUsername", String(data.hrAccount || ""));
              } catch (err) {}
              if (data.userId != null) {
                try {
                  store.commit("setUserId", String(data.userId));
                } catch (err) {}
              }
              try {
                router.replace("/hr/measure-result-for-hr");
              } catch (err) {}
            })
            .catch(function() {});
        } catch (err) {}
      }
    }
  });
} catch (err) {}



// WEBPACK FOOTER //
// ./src/main.js